import React, {useContext, useMemo} from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import {useModal} from '@tager/web-components';
import {Nullable} from '@tager/web-core';

import TextWithIcon from '@/components/TextWithIcon';
import {useTypedSelector} from '@/store/store';
import {selectActiveId,} from '@/store/reducers/pages/product/product';
import CheaperForm from '@/components/Forms/CheaperForm';
import {productContext} from '@/providers/Product';
import {FullProductType} from '@/typings/model';

type Props = {
  product: Nullable<FullProductType>;
};

const Cheaper = ({product}: Props) => {
  const openModal = useModal();

  const t = useTranslations();

  const activeIndex = useTypedSelector((state) => selectActiveId(state));
  const {price, discountPrice, optionData} = useContext(productContext);

  const productData = useMemo(() => {
    if (!product) {
      return null;
    }

    const id = product.id;
    const name = product?.name ?? '';
    const image = !!product?.gallery.length
      ? product.gallery[activeIndex]?.image?.preview
      : null;
    const productPrice = price;
    const productDiscountPrice = discountPrice;
    const optionName = product?.multiplePricesEnabled
      ? optionData?.optionName
      : null;
    const optionValue = product?.multiplePricesEnabled
      ? optionData?.optionValue
      : null;
    const hasDiscount = true;

    return {
      id,
      name,
      image,
      price: productPrice,
      discountPrice: productDiscountPrice,
      optionName,
      optionValue,
      hasDiscount,
    };
  }, [
    activeIndex,
    product,
    discountPrice,
    optionData?.optionName,
    optionData?.optionValue,
    price,
  ]);

  const handler = () => {
    openModal(
      CheaperForm,
      {
        title: t('forms.leave_request'),
        orderData: productData && {...productData, hasDiscount: false},
      },
      {withAnimation: false, scrollLockDisabled: true}
    );
  };

  return (
    <Component>
      <TextWithIcon
        icon="wallet"
        note={t('forms.find_cheaper')}
        text={t('forms.write_us')}
        textButton
        fontWeight="normal"
        onClick={handler}
      />
    </Component>
  );
};

export default Cheaper;

const Component = styled.div``;
